import { render, staticRenderFns } from "./example4.vue?vue&type=template&id=11af260a&lang=html&"
import script from "./example4.vue?vue&type=script&lang=js&"
export * from "./example4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "example4.vue"
export default component.exports